import { render, staticRenderFns } from "./MonitorQualidade.vue?vue&type=template&id=72eda074&scoped=true&"
import script from "./MonitorQualidade.vue?vue&type=script&lang=js&"
export * from "./MonitorQualidade.vue?vue&type=script&lang=js&"
import style0 from "./MonitorQualidade.vue?vue&type=style&index=0&id=72eda074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eda074",
  null
  
)

export default component.exports